export enum RuntimeType {
  AnimatedSprite = 'AnimatedSprite',
  TilingSprite = 'TilingSprite',
  OutOfLivesButtonView = 'OutOfLivesButtonView',
  CircularProgressBar = 'CircularProgressBar',
}
